export const ORDER_STATUS_CREATED = "CREATED";
export const ORDER_STATUS_PAYMENT_PENDING = "PAYMENT_PENDING";
export const ORDER_STATUS_PAID = "PAID";
export const ORDER_STATUS_READY_FOR_SHIPPING = "READY_FOR_SHIPPING";
export const ORDER_STATUS_PICKED_UP = "PICKED_UP";
export const ORDER_STATUS_IN_TRANSIT = "IN_TRANSIT";
export const ORDER_STATUS_DELIVERED = "DELIVERED";
export const ORDER_STATUS_COMPLETED = "COMPLETED";
export const ORDER_STATUS_RETURNED = "RETURNED";
export const ORDER_STATUS_RECEIVED = "RECEIVED";

// Purchase Order Statuses
export const PURCHASE_ORDER_STATUS_DRAFT = "draft";
export const PURCHASE_ORDER_STATUS_ORDERED = "ordered";
export const PURCHASE_ORDER_STATUS_PENDING_CONFIRMATION = "pending_confirmation";
export const PURCHASE_ORDER_STATUS_PENDING_APPROVAL = "pending_approval";
export const PURCHASE_ORDER_STATUS_PENDING_SUPPLIER_REVIEW = "pending_supplier_review";
export const PURCHASE_ORDER_STATUS_PAYMENT_PENDING = "payment_pending"; // DEPRECATED: Use PURCHASE_ORDER_PAYMENT_STATUS_PENDING instead
export const PURCHASE_ORDER_STATUS_DEPOSIT_PAID = "deposit_paid"; // DEPRECATED: Use PURCHASE_ORDER_PAYMENT_STATUS_DEPOSIT_PAID instead
export const PURCHASE_ORDER_STATUS_PAID = "paid"; // DEPRECATED: Use PURCHASE_ORDER_PAYMENT_STATUS_PAID instead
export const PURCHASE_ORDER_STATUS_READY_FOR_PRODUCTION = "ready_for_production";
export const PURCHASE_ORDER_STATUS_IN_PRODUCTION = "in_production";
export const PURCHASE_ORDER_STATUS_PARTIALLY_SHIPPED = "partially_shipped";
export const PURCHASE_ORDER_STATUS_SHIPPED = "shipped";
export const PURCHASE_ORDER_STATUS_RECEIVED = "received";
export const PURCHASE_ORDER_STATUS_UNDER_REVIEW = "under_review";
export const PURCHASE_ORDER_STATUS_COMPLETED = "completed";
export const PURCHASE_ORDER_STATUS_CANCELLED = "cancelled";
// Order splitsen bestaat niet meer (BMX-11); deze status wordt nergens meer
// gezet. Hij blijft staan omdat orders van vóór juni 2026 hem nog hebben — zonder
// dit label tonen die een kapotte statustag.
export const PURCHASE_ORDER_STATUS_SPLIT = "split";

/**
 * De statussen die een inkooporder in de schermen kan krijgen, in de volgorde van het proces
 * (BMX-14).
 *
 * Bewust géén lijst van alles wat hierboven staat. Van de 14 constanten worden er zeven niet
 * meer gezet, en ze stonden wél door elkaar in de keuzelijsten van het overzicht en de
 * detailpagina — met als gevolg dat iemand een order handmatig op een status kon zetten waar
 * de rest van het systeem niets meer mee doet:
 *
 * - `received` en `under_review`: de bedoelde ontvangst/telcontrole-flow op de órder is nooit
 *   afgemaakt; `under_review` werd letterlijk nergens geschreven, waardoor de knop "Afronden"
 *   (`canComplete = isUnderReview && hasReview`) onbereikbaar was. Het tellen zelf gebeurt op de
 *   verzending ("Verwerk ontvangst"), en dáárop rondt de order nu automatisch af.
 * - `ordered`: nooit gebruikt in het CMS.
 * - `payment_pending` / `deposit_paid` / `paid`: betaalstatussen die ooit in het statusveld
 *   zaten; betalingen lopen nu via facturen en `purchaseOrderPayments`.
 * - `split`: order splitsen bestaat niet meer (BMX-11).
 *
 * Alle constanten, kleuren en labels blijven staan: er is productiedata met die waarden, en
 * zonder label rendert zo'n order een kapotte statustag. Ze zijn alleen niet meer kiesbaar.
 */
export const PURCHASE_ORDER_SELECTABLE_STATUSES = [
  PURCHASE_ORDER_STATUS_DRAFT,
  PURCHASE_ORDER_STATUS_PENDING_CONFIRMATION,
  PURCHASE_ORDER_STATUS_PENDING_APPROVAL,
  PURCHASE_ORDER_STATUS_PENDING_SUPPLIER_REVIEW,
  PURCHASE_ORDER_STATUS_READY_FOR_PRODUCTION,
  PURCHASE_ORDER_STATUS_IN_PRODUCTION,
  PURCHASE_ORDER_STATUS_PARTIALLY_SHIPPED,
  PURCHASE_ORDER_STATUS_SHIPPED,
  PURCHASE_ORDER_STATUS_COMPLETED,
  PURCHASE_ORDER_STATUS_CANCELLED,
];

// ── Verzendstatussen bij inkoop (purchaseOrderShipments.status) ──
//
// Stonden met de hand gekopieerd op drie plekken (zendingoverzicht, zendingdetail,
// inkooporderdetail) en liepen uit elkaar: op de detailpagina ontbrak het label voor
// `in_transit`, waardoor zo'n zending letterlijk "in_transit" als tag toonde.
export const PURCHASE_ORDER_SHIPMENT_STATUS_COLORS = {
  draft: "default",
  shipped: "blue",
  in_transit: "orange",
  received: "green",
  completed: "cyan",
  cancelled: "red",
};

export const PURCHASE_ORDER_SHIPMENT_STATUS_LABELS = {
  draft: "Concept",
  shipped: "Verzonden",
  in_transit: "Onderweg",
  received: "Ontvangen",
  completed: "Afgerond",
  cancelled: "Geannuleerd",
};

/**
 * De verzendstatussen die je zelf kunt kiezen (BMX-14).
 *
 * `in_transit` ("Onderweg") staat er bewust niet meer bij. Niets in het CMS, het
 * leveranciersportaal of de Cloud Functions zette die status ooit; hij was alleen met de hand
 * te kiezen en betekende in de praktijk hetzelfde als `shipped` — precies de overbodige status
 * die deze story eruit vraagt te halen. Het label blijft hierboven staan voor zendingen die hem
 * nog hebben.
 *
 * De werkelijke gang van zaken is: `shipped` (het portaal maakt zo aan) → `received` (Bombyxx
 * zet 'm als de container binnen is) → `completed` (na "Verwerk ontvangst"). Op die laatste stap
 * rondt de gekoppelde order nu automatisch af.
 */
export const PURCHASE_ORDER_SHIPMENT_SELECTABLE_STATUSES = [
  "draft",
  "shipped",
  "received",
  "completed",
  "cancelled",
];

// Purchase Order Payment Statuses (separate from order status)
export const PURCHASE_ORDER_PAYMENT_STATUS_PENDING = "payment_pending";
export const PURCHASE_ORDER_PAYMENT_STATUS_DEPOSIT_PAID = "deposit_paid";
export const PURCHASE_ORDER_PAYMENT_STATUS_PAID = "paid";

// Shop Order Payment Statuses
export const PAYMENT_STATUS_NOT_SENT = "not_sent";
export const PAYMENT_STATUS_SENT = "sent";
export const PAYMENT_STATUS_PAID = "paid";
export const PAYMENT_STATUS_REFUNDED = "refunded";
export const PAYMENT_STATUS_OVERDUE = "overdue";

// Product Draft Statuses
export const PRODUCT_DRAFT_STATUS_NEEDS_SUPPLIER_INPUT = "needs_supplier_input";
export const PRODUCT_DRAFT_STATUS_SUBMITTED = "submitted";
export const PRODUCT_DRAFT_STATUS_CHANGES_REQUESTED = "changes_requested";
export const PRODUCT_DRAFT_STATUS_APPROVED = "approved";
export const PRODUCT_DRAFT_STATUS_PUBLISHED = "published";
